import messagesReducer from './messagesReducer';

export default messagesReducer;
